import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GraphForm } from '@/features/editor/graph-form';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/editor/new')({ component: NewGraphRoute });

function NewGraphRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="editor"
      crumbs={[{ label: t('nav.items.editor') }, { label: t('editor.newTitle') }]}
    >
      <GraphForm tenantId={tenant} />
    </ConsoleShell>
  );
}
